import { configureStore } from "@reduxjs/toolkit";
import uploadMediaReducer from "./uploadMediaSlice";
import coachDataReducer from "./coachDataSlice";
import collaboratorDataReducer from "./collaboratorDataSlice";
import categoryIconReducer from "./categoryIconSlice";
import currentClassReducer from "./currentClassSlice";
import userDataReducer from "./userDataSlice";
import utilsReducer from "./utilsSlice";

const store = configureStore({
    reducer: {
        uploadMedia: uploadMediaReducer,
        coachData: coachDataReducer,
        collaboratorData: collaboratorDataReducer,
        categoryIcon: categoryIconReducer,
        userData: userDataReducer,
        utilsData: utilsReducer,
        currentClass: currentClassReducer
    }
});

export default store;